module.exports = __webpack_public_path__ + "static/media/pic_dni.7c9afd1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_dni.jpg
// module id = 653
// module chunks = 0